import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { firstValueFrom, map } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class HoursOperationService {

  API_URL = environment.apiGatewayURL;
  constructor(private http: HttpClient) {}

  saveEstadoOperacion(estadoOperacion: any): Promise<any> {
    const serviceURL = `${this.API_URL}save-estado-operacion`;
    return firstValueFrom(this.http.post(serviceURL, estadoOperacion));
  }

  getEstadoOperacion(tipo:string): Promise<boolean>{
    const serviceURL = `${this.API_URL}estado-operacion/${tipo}`;
    return firstValueFrom(this.http.get(serviceURL).pipe(map((response: any) => response?.estado ?? false)));
  }
}
